import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import NewtonDividedByMillimetreSquared from "../../../../components/Math/Units/Metric/NewtonDividedByMillimetreSquared";
import { RowBody } from "../../../../components/RowValue/RowBody";
import {
  selectDruckfestigkeitZement,
  setBetonzugfestigkeit,
  setDruckfestigkeitZement,
} from "../../../../store/slices/aeussereSlice";

function CompressiveStrengthOfConcrete() {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const druckfestigkeitZement = useSelector(selectDruckfestigkeitZement);

  return (
    <RowBody
      titleValue={<p>{t("aeussre.compressiveStrengthConcrete")}</p>}
      indicesValue={
        <span>
          f<sub>ck</sub>
        </span>
      }
      inputValue={
        <select
          className="change-input"
          name="druckfestigkeitZement"
          onChange={(e) => {
            dispatch(setDruckfestigkeitZement(Number(e.target.value)));
            dispatch(setBetonzugfestigkeit(e.target.options[e.target.selectedIndex].text));
          }}
          value={druckfestigkeitZement}
        >
          <option value={1.1}>12</option>
          <option value={1.3}>16</option>
          <option value={1.5}>20</option>
          <option value={1.8}>25</option>
          <option value={2}>30</option>
          <option value={2.2}>35</option>
          <option value={2.5}>40</option>
          <option value={2.7}>45</option>
          <option value={2.9}>50</option>
          <option value={3}>55</option>
          <option value={3.1}>60</option>
          <option value={3.2}>70</option>
          <option value={3.4}>80</option>
          <option value={3.5}>90</option>
        </select>
      }
      unitValue={<NewtonDividedByMillimetreSquared />}
    />
  );
}

export default CompressiveStrengthOfConcrete;
